import type { UserMfaSettings } from '@repo/database/src/types';
import type { UserDefaultArgs, UserGetPayload } from '@repo/database/src/types';
import { IsBoolean, IsOptional, IsString } from 'class-validator';

export const userPublic = {
  omit: {
    email: true,
    phone: true,
    dialingCode: true,
    createdAt: true,
    updatedAt: true,
  },
} satisfies UserDefaultArgs;

export type UserPublic = UserGetPayload<typeof userPublic>;

export const userWithIncludes = {
  include: {
    tier: true,
    settings: true,
    kyc: true,
    avaturnUser: true,
    lobbyFilters: true,
    userAgreements: {
      where: { isActive: true },
      select: { agreement: true, isActive: true },
    },
  },
} satisfies UserDefaultArgs;
export type UserDto = UserGetPayload<typeof userWithIncludes>;

export type AdminUserDto = UserDto & {
  mfaSettings: UserMfaSettings | null;
};

export const userSimple = {
  select: {
    id: true,
    firstName: true,
    lastName: true,
    alias: true,
    smartWalletAddress: true,
  },
} satisfies UserDefaultArgs;
export type UserSimple = UserGetPayload<typeof userSimple>;

export class UserUpdateReqDto {
  @IsOptional()
  @IsString()
  visitorId?: string | null;

  @IsOptional()
  @IsString()
  smartWalletAddress?: string;

  @IsOptional()
  @IsBoolean()
  privacyModeEnabled?: boolean;

  @IsOptional()
  @IsBoolean()
  streamingNow?: boolean;
}

export class LogoutDuplicatedUserDto {
  @IsString()
  visitorId: string;
}
